import {RequestStatus} from '@innowise-group/core';
import {WorkspaceRequestStatus} from '../requests-api';

export const API_TO_INTERNAL_STATUS_MAP: Record<WorkspaceRequestStatus, RequestStatus> = {
  'In progress': 'in-clarification',
  Approved: 'approved',
  Rejected: 'rejected',
  Delayed: 'delayed',
  Canceled: 'canceled',
  Conflict: 'conflict',
} as const;

export const INTERNAL_TO_API_STATUS_MAP: Record<RequestStatus, WorkspaceRequestStatus> = {
  'in-clarification': 'In progress',
  approved: 'Approved',
  rejected: 'Rejected',
  delayed: 'Delayed',
  canceled: 'Canceled',
  conflict: 'Conflict',
} as const;
